import React, { useEffect, useState } from 'react';
import Interweave from 'interweave';
import { withStyles } from '@mui/styles';
import { getConnectorScore, getShortlistActions } from './ConnectorService';
import { PubSub } from '../../utils/eventUtils';
import SimpleTooltip from '../../components/SimpleTooltip';
import { toUniversalUtcDate } from '../../utils/date.utils';

const ConnectorQuickView = ({ classes, data, theme, ...props }: any) => {
  const [myConnector, setMyConnector] = useState(data);
  const [myData, setMyData] = useState(null);
  const { open } = props;
  const renderGCPScores = () => {
    const { score } = myData;
    let result = null;
    const { total, encryption, identity, infrastructure, network } = score;
    const dataScores = score.data;

    if (total) {
      result = (
        <section className={classes.detailsSection}>
          <section className={classes.sectionTitleContainerGCP}>
            <h3 className={classes.sectionTitle}>
              {shareData[myConnector.connectorType].title}
            </h3>
            <section className={classes.asOfContainer}>
              <span className={classes.asOf}>
                As of: 
                {toUniversalUtcDate(myData.score.lastPull)}
              </span>
            </section>
          </section>
          <p className={classes.gcpTotalText}>
            (<span className={classes.myScore}>Total</span>
            <span className={classes.maxScore}> = High + </span>Medium)
          </p>
          <section>
            <section className={classes.totalScoreLine}>
              <div className={classes.totalScoreHeader}>Score:</div>
              <div className={classes.totalScoresCol}>
                <p className={classes.myScore}>
                  {total.totalCount}
                  <span className={classes.maxScore}>
                    {' '}
                    = {total.highCount} +{' '}
                    <span className={classes.mediumCount}>
                      {total.mediumCount}
                    </span>
                  </span>
                </p>
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Identity</p>
                <p className={classes.scoreHeaderDes}>
                  Security state of User’s role and access
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof identity === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {identity.totalCount}
                    <span className={classes.maxScore}>
                      {' '}
                      = {identity.highCount} +{' '}
                      <span className={classes.mediumCount}>
                        {identity.mediumCount}
                      </span>
                    </span>
                  </p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Network</p>
                <p className={classes.scoreHeaderDes}>
                  Security state of Networks and Routes
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof network === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {network.totalCount}
                    <span className={classes.maxScore}>
                      {' '}
                      = {network.highCount} +{' '}
                      <span className={classes.mediumCount}>
                        {network.mediumCount}
                      </span>
                    </span>
                  </p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Data</p>
                <p className={classes.scoreHeaderDes}>
                  State of Cloud Data Integrity
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof dataScores === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {dataScores.totalCount}
                    <span className={classes.maxScore}>
                      {' '}
                      = {dataScores.highCount} +{' '}
                      <span className={classes.mediumCount}>
                        {dataScores.mediumCount}
                      </span>
                    </span>
                  </p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Infrastructure</p>
                <p className={classes.scoreHeaderDes}>
                  Security state of Asset Inventory
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof infrastructure === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {infrastructure.totalCount}
                    <span className={classes.maxScore}>
                      {' '}
                      = {infrastructure.highCount} +{' '}
                      <span className={classes.mediumCount}>
                        {infrastructure.mediumCount}
                      </span>
                    </span>
                  </p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Encryption</p>
                <p className={classes.scoreHeaderDes}>
                  State of Encryption Integrity
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof encryption === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {encryption.totalCount}
                    <span className={classes.maxScore}>
                      {' '}
                      = {encryption.highCount} +{' '}
                      <span className={classes.mediumCount}>
                        {encryption.mediumCount}
                      </span>
                    </span>
                  </p>
                )}
              </div>
            </section>
          </section>
        </section>
      );
    }
    return result;
  };

  const renderAWSScores = () => {
    const { score } = myData;
    let result;

    const { overall, identity, infrastructure, apps, regulation } = score;

    if (overall) {
      result = (
        <section className={classes.detailsSection}>
          <section className={classes.sectionTitleContainer}>
            <h3 className={classes.sectionTitle}>
              {shareData[myConnector.connectorType].title}
            </h3>
            <section className={classes.asOfContainer}>
              <span className={classes.asOf}>
                 As of:{' '}
                {toUniversalUtcDate(myData.score.lastPull)}
              </span>
            </section>
          </section>
          <section>
            <section className={classes.totalScoreLine}>
              <div className={classes.totalScoreHeader}>Total Score:</div>
              <div className={classes.totalScoresCol}>
                <p className={classes.myScore}>
                  {parseInt(overall.total.passed)}
                  <span className={classes.maxScore}>
                    {' '}
                    / {parseInt(overall.total.passed + overall.total.failed)}
                  </span>
                </p>
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Identity</p>
                <p className={classes.scoreHeaderDes}>
                  Protection state of your AWS accounts and roles
                </p>
              </div>
              <div className={classes.awsScoresColumn}>
                {typeof identity === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {parseInt(identity.total.passed)}
                    <span className={classes.maxScore}>
                      {' '}
                      /{' '}
                      {parseInt(identity.total.passed + identity.total.failed)}
                    </span>
                  </p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Data</p>
                <p className={classes.scoreHeaderDes}>
                  Protection state of your AWS documents and data
                </p>
              </div>
              <div className={classes.awsScoresColumn}>
                {typeof data === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {parseInt(identity.total.passed)}
                    <span className={classes.maxScore}>
                      {' '}
                      /{' '}
                      {parseInt(identity.total.passed + identity.total.failed)}
                    </span>
                  </p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Apps</p>
                <p className={classes.scoreHeaderDes}>
                  Protection state of your email and cloud apps
                </p>
              </div>
              <div className={classes.awsScoresColumn}>
                {typeof apps === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {parseInt(apps.total.passed)}
                    <span className={classes.maxScore}>
                      {' '}
                      / {parseInt(apps.total.passed + apps.total.failed)}
                    </span>
                  </p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Infrastructure</p>
                <p className={classes.scoreHeaderDes}>
                  Protection state of your AWS resources
                </p>
              </div>
              <div className={classes.awsScoresColumn}>
                {typeof infrastructure === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {parseInt(infrastructure.total.passed)}
                    <span className={classes.maxScore}>
                      {' '}
                      /{' '}
                      {parseInt(
                        infrastructure.total.failed +
                          infrastructure.total.passed
                      )}
                    </span>
                  </p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Regulations</p>
                <p className={classes.scoreHeaderDes}>
                  Security Standards determined by PCI DSS and CIS organizations
                </p>
              </div>
              <div className={classes.awsScoresColumn}>
                {typeof regulation === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>
                    {parseInt(regulation.total.passed)}
                    <span className={classes.maxScore}>
                      {' '}
                      /{' '}
                      {parseInt(
                        regulation.total.failed + regulation.total.passed
                      )}
                    </span>
                  </p>
                )}
              </div>
            </section>
          </section>
        </section>
      );
    }

    return result;
  };

  const renderMicrosoftScores = () => {
    const { score } = myData;
    if (score) {
      const { averageComparativeScores } = score;
      let result = null;
      averageComparativeScores.forEach((item: any) => {
        if (item.basis === 'me') {
          const {
            averageScore,
            maxScore,
            deviceScore,
            dataScore,
            identityScore,
            appsScore,
            maxDeviceScore,
            maxDataScore,
            maxIdentityScore,
            maxAppsScore,
            infrastructureScore,
            maxInfrastructureScore,
          } = item;
          result = (
            <section className={classes.detailsSection}>
              <section className={classes.sectionTitleContainer}>
                <h3 className={classes.sectionTitle}>
                  {shareData[myConnector.connectorType].title}
                </h3>
                <section className={classes.asOfContainer}>
                  <span className={classes.asOf}>
                     As of:{' '}
                    {toUniversalUtcDate(myData.score.lastPull)}
                  </span>
                </section>
              </section>
              <section>
                <section className={classes.totalScoreLine}>
                  <div className={classes.totalScoreHeader}>Total Score:</div>
                  <div className={classes.totalScoresCol}>
                    <p className={classes.myScore}>
                      {averageScore}
                      <span className={classes.maxScore}> / {maxScore}</span>
                    </p>
                  </div>
                </section>
                <section className={classes.scoreLine}>
                  <div className={classes.scoreHeaderContainer}>
                    <p className={classes.scoreHeader}>Identity</p>
                    <p className={classes.scoreHeaderDes}>
                      Protection state of your Azure AD accounts and roles
                    </p>
                  </div>
                  <div className={classes.scoresColum}>
                    {typeof identityScore === 'undefined' ? (
                      <p className={classes.noDataShow}>No data to show</p>
                    ) : (
                      <p className={classes.myScore}>
                        {identityScore}
                        <span className={classes.maxScore}>
                          {' '}
                          / {maxIdentityScore}
                        </span>
                      </p>
                    )}
                  </div>
                </section>
                <section className={classes.scoreLine}>
                  <div className={classes.scoreHeaderContainer}>
                    <p className={classes.scoreHeader}>Data</p>
                    <p className={classes.scoreHeaderDes}>
                      Protection state of your Office 365 documents
                    </p>
                  </div>
                  <div className={classes.scoresColum}>
                    {typeof dataScore === 'undefined' ? (
                      <p className={classes.noDataShow}>No data to show</p>
                    ) : (
                      <p className={classes.myScore}>
                        {dataScore}
                        <span className={classes.maxScore}>
                          {' '}
                          / {maxDataScore}
                        </span>
                      </p>
                    )}
                  </div>
                </section>
                <section className={classes.scoreLine}>
                  <div className={classes.scoreHeaderContainer}>
                    <p className={classes.scoreHeader}>Device</p>
                    <p className={classes.scoreHeaderDes}>
                      Protection state of your devices
                    </p>
                  </div>
                  <div className={classes.scoresColum}>
                    {typeof deviceScore === 'undefined' ? (
                      <p className={classes.noDataShow}>No data to show</p>
                    ) : (
                      <p className={classes.myScore}>
                        {deviceScore}
                        <span className={classes.maxScore}>
                          {' '}
                          / {maxDeviceScore}
                        </span>
                      </p>
                    )}
                  </div>
                </section>
                <section className={classes.scoreLine}>
                  <div className={classes.scoreHeaderContainer}>
                    <p className={classes.scoreHeader}>Apps</p>
                    <p className={classes.scoreHeaderDes}>
                      Protection state of your email and cloud apps
                    </p>
                  </div>
                  <div className={classes.scoresColum}>
                    {typeof appsScore === 'undefined' ? (
                      <p className={classes.noDataShow}>No data to show</p>
                    ) : (
                      <p className={classes.myScore}>
                        {appsScore}
                        <span className={classes.maxScore}>
                          {' '}
                          / {maxAppsScore}
                        </span>
                      </p>
                    )}
                  </div>
                </section>
                <section className={classes.scoreLine}>
                  <div className={classes.scoreHeaderContainer}>
                    <p className={classes.scoreHeader}>Infrastructure</p>
                    <p className={classes.scoreHeaderDes}>
                      Protection state of your Azure resources
                    </p>
                  </div>
                  <div className={classes.scoresColum}>
                    {typeof infrastructureScore === 'undefined' ? (
                      <p className={classes.noDataShow}>No data to show</p>
                    ) : (
                      <p className={classes.myScore}>
                        {infrastructureScore}
                        <span className={classes.maxScore}>
                          {' '}
                          / {maxInfrastructureScore}
                        </span>
                      </p>
                    )}
                  </div>
                </section>
              </section>
            </section>
          );
        }
      });
      return result;
    }
    return null;
  };

  const renderSecurityStudioScores = () => {
    const { score } = myData;
    let result = null;
    const {
      total,
      administrativeControl,
      externalTechnicalControl,
      internalTechnicalControl,
      physicalControl,
    } = score;
    if (total) {
      result = (
        <section className={classes.detailsSection}>
          <section className={classes.sectionTitleContainerSecurityStudio}>
            <h3 className={classes.sectionTitle}>
              {shareData[myConnector.connectorType].title}
            </h3>
            <section className={classes.asOfContainer}>
              <span className={classes.asOf}>
                 As of:{' '}
                {toUniversalUtcDate(myData.score.lastPull)}
              </span>
            </section>
          </section>
          <section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p
                  className={classes.scoreHeader}
                  style={{ fontSize: '1.5rem' }}
                >
                  Total Score
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof total === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>{total}</p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Administrative</p>
                <p className={classes.scoreHeaderDes}>
                  Assessment of security policies and guidelines
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof administrativeControl === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>{administrativeControl}</p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Physical</p>
                <p className={classes.scoreHeaderDes}>
                  Assessment of information security strategy
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof physicalControl === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>{physicalControl}</p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>Internal</p>
                <p className={classes.scoreHeaderDes}>
                  Assessment of firewalls and anti-virus software
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof internalTechnicalControl === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>{internalTechnicalControl}</p>
                )}
              </div>
            </section>
            <section className={classes.scoreLine}>
              <div className={classes.scoreHeaderContainer}>
                <p className={classes.scoreHeader}>External</p>
                <p className={classes.scoreHeaderDes}>
                  Assessment of DNS, social media, and vulnerability scanning
                </p>
              </div>
              <div className={classes.scoresColum}>
                {typeof externalTechnicalControl === 'undefined' ? (
                  <p className={classes.noDataShow}>No data to show</p>
                ) : (
                  <p className={classes.myScore}>{externalTechnicalControl}</p>
                )}
              </div>
            </section>
          </section>
        </section>
      );
    }
    return result;
  };

  const renderMicrosoftShortlistActions = () => {
    const { shortlistActions } = myData;
    if (shortlistActions) {
      return shortlistActions.map((item: any, idx: any) => (
        <section className={classes.improvementContainer}>
          <section className={classes.improvementItemContainer}>
            <p className={classes.shortListTitle}>
              {idx + 1}. {item.title}
            </p>
          </section>
        </section>
      ));
    }

    return null;
  };

  const renderAWSShortlistActions = () => {
    const { shortlistActions } = myData;
    // placing a !shortlistActions check here as BE is still working on refining these data values
    if (!shortlistActions) {
      return shortlistActions.map((item: any, idx: any) => (
        <section className={classes.improvementContainer}>
          <section className={classes.improvementItemContainer}>
            <p className={classes.shortListTitle}>
              {idx + 1}. {item.title}
            </p>
          </section>
        </section>
      ));
    }

    return null;
  };

  const renderSecurityStudioShortlistActions = () => {
    const { shortlistActions } = myData;
    if (shortlistActions) {
      return shortlistActions.map((item: any, idx: any) => (
        <section className={classes.improvementContainer}>
          <section className={classes.improvementItemContainer}>
            <p className={classes.shortListTitle}>
              {idx + 1}. {item.recommendationTaskName}
            </p>
          </section>
        </section>
      ));
    }

    return null;
  };

  const renderGCPShortlistActions = () => {
    const { shortlistActions } = myData;
    if (shortlistActions) {
      return shortlistActions.map((item: any, idx: any) => (
        <section className={classes.improvementContainer}>
          <section className={classes.improvementItemContainer}>
            <section className={classes.gcpActionItem}>
              {idx + 1}.{' '}
              <SimpleTooltip
                title={
                  item.findingSourcepropertiesRecommendationCount > 65 ? (
                    <Interweave
                      content={item.findingSourcepropertiesRecommendation}
                    />
                  ) : (
                    ''
                  )
                }
              >
                <Interweave
                  content={item.findingSourcepropertiesRecommendation}
                />
              </SimpleTooltip>
            </section>
          </section>
        </section>
      ));
    }

    return null;
  };

  const shareData = {
    MICROSOFT: {
      title: 'Microsoft Secure Score',
      renderScores: renderMicrosoftScores,
      renderShortlistActions: renderMicrosoftShortlistActions,
    },
    GOOGLE: {
      title: 'Google Command Center',
      renderScores: renderGCPScores,
      renderShortlistActions: renderGCPShortlistActions,
    },
    SECURITYSTUDIO: {
      title: 'Security Studio',
      renderScores: renderSecurityStudioScores,
      renderShortlistActions: renderSecurityStudioShortlistActions,
    },
    AWS: {
      title: 'Amazon Web Services',
      renderScores: renderAWSScores,
      renderShortlistActions: renderAWSShortlistActions,
    },
  };

  useEffect(() => {
    if (!myData && open) {
      const { connectorType, id } = myConnector;
      Promise.all([
        getConnectorScore({
          connectorType: connectorType.toLowerCase(),
          connectorId: id,
        }),
        getShortlistActions({
          connectorType: connectorType.toLowerCase(),
          connectorId: id,
        }),
      ])
        .then((responses) => {
          setMyData({
            score: responses[0].data,
            shortlistActions: responses[1].data.content,
          });
        })
        .catch(console.error.bind(console));
    }

    const sub = PubSub.subscribe(
      'ConnectorQuickViewContainer:render',
      (connector: any) => {
        setMyConnector(connector);
        setMyData(null);
      }
    );

    return () => {
      sub.remove();
    };
  });

  if (myData && open) {
    return (
      <section className={classes.container}>
        {shareData[myConnector.connectorType].renderScores()}
        <section className={classes.detailsSection}>
          <section className={classes.sectionTitleContainer}>
            <h3 className={classes.sectionTitle}>Improvement Actions</h3>
          </section>
          {shareData[myConnector.connectorType].renderShortlistActions()}
        </section>
      </section>
    );
  }
  return null;
};

const styles = ({ palette }: any) => {
  return {
    gcpActionItem: {
      display: 'flex',
      flexDirection: 'row',
      '& .expand-icon': {
        width: '28.33rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    button: {
      padding: '5px !important',
      border: `1px solid ${palette.primary.border2}`,
    },
    shortListTitle: {
      margin: '0 !important',
    },
    simpleTooltip: {
      padding: 10,
      marginBottom: 5,
      border: `1px solid  ${palette.common.cowbellBlue}`,
      backgroundColor: palette.background.default,
      color: palette.text.text7,
      fontSize: '0.833rem',
    },
    asOfContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    sectionTitleContainer: {
      display: 'flex',
      flexDirection: 'row',
      borderBottom: `1px solid ${palette.primary.border2}`,
      paddingBottom: 5,
      marginBottom: 20,
      color: palette.text.message,
      justifyContent: 'space-between',
    },
    sectionTitleContainerGCP: {
      display: 'flex',
      flexDirection: 'row',
      borderBottom: `1px solid ${palette.primary.border2}`,
      paddingBottom: 5,
      color: palette.text.message,
      justifyContent: 'space-between',
    },
    sectionTitleContainerSecurityStudio: {
      display: 'flex',
      flexDirection: 'row',
      borderBottom: `1px solid ${palette.primary.border2}`,
      paddingBottom: 5,
      color: palette.text.message,
      justifyContent: 'space-between',
      marginBottom: '3.5rem',
    },
    tooltipIcon: {
      width: '1.667rem',
      height: '1.667rem',
    },
    asOf: {
      fontSize: '1.167rem',
      lineHeight: 1.21,
      marginRight: 5,
      paddingTop: 2,
    },
    improvementItemNotCompletedCount: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 0.57,
      textAlign: 'center',
      color: palette.primary.yellow1,
      paddingTop: 10,
      borderTop: `2px solid ${palette.primary.yellow1}`,
      margin: '0 !important',
    },
    improvementItemContainer: {},
    improvementItemTitle: {
      fontSize: '1rem',
      lineHeight: 1,
      textAlign: 'left',
      color: palette.primary.main,
      margin: '0 0 3px 0 !important',
    },
    improvementItemCompletedCount: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 0.57,
      textAlign: 'center',
      color: palette.primary.green1,
      paddingTop: 10,
      borderTop: `2px solid ${palette.primary.green1}`,
      margin: '0 !important',
    },
    improvementContainer: {
      textAlign: 'left',
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.33,
      color: palette.text.primary,
      backgroundColor: palette.background.lighter,
      marginBottom: 5,
      padding: '0.83rem 0.4167rem',
    },
    detailsSection: {
      marginBottom: 20,
    },
    totalScoreLine: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 15,
      justifyContent: 'space-between',
    },
    totalScoreHeader: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 0.94,
      textAlign: 'left',
      color: palette.text.text14,
    },
    totalScoresCol: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 0.94,
      textAlign: 'right',
    },
    scoresColum: {
      fontSize: '1.167rem',
      fontWeight: 600,
      lineHeight: 0.94,
      textAlign: 'right',
      paddingTop: 10,
    },
    awsScoresColumn: {
      fontSize: '1.167rem',
      fontWeight: 600,
      lineHeight: 0.94,
      textAlign: 'right',
      paddingTop: 10,
      width: '5.625rem',
    },
    myScore: {
      color: palette.primary.main,
      margin: '0 !important',
    },
    maxScore: {
      color: palette.text.text15,
    },
    scoreLine: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 15,
      justifyContent: 'space-between',
    },
    scoreHeaderContainer: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
    },
    scoreHeader: {
      fontSize: '1.167rem',
      fontWeight: 600,
      color: palette.text.text14,
      margin: '0 !important',
    },
    scoreHeaderDes: {
      fontSize: '1rem',
      textAlign: 'left',
      lineHeight: 1.42,
      color: palette.text.text7,
      margin: '0 !important',
    },
    noDataShow: {
      fontSize: '1.167rem',
      textAlign: 'right',
      lineHeight: 1.21,
      color: palette.text.primary,
      margin: '0 !important',
    },
    sectionTitle: {
      fontSize: '1.33rem',
      lineHeight: 1.06,
      textAlign: 'left',
      margin: '0 !important',
      paddingTop: 2,
    },
    detailsButton: {
      width: '7.5rem',
      height: '1.667rem',
      borderRadius: 5,
      border: `1px solid ${palette.primary.green}`,
      margin: '0 auto 15px auto',
      color: palette.primary.main,
      fontSize: '1.083rem',
      lineHeight: 1.33,
      paddingTop: 1,
      cursor: 'pointer',
      textTransform: 'uppercase',
    },
    mainContainer: {
      width: '34.583rem',
      height: '100%',
      padding: '11px 26px',
      textAlign: 'center',
      backgroundColor: palette.background.dark,
    },
    title: {
      fontSize: '1.167rem',
      lineHeight: 1.5,
      fontWeight: 'bold',
      color: palette.primary.main,
      paddingBottom: 2,
      borderBottom: `1px solid ${palette.primary.modalBorder}`,
      margin: '0px 0 20px 0 !important',
    },
    iconStyle: {
      width: '10rem',
      height: '5rem',
      textAlign: 'center',
      marginBottom: 20,
    },
    mediumCount: {
      color: palette.text.text15,
    },
    gcpTotalText: {
      fontSize: '1rem',
      lineHeight: 1.42,
      textAlign: 'right',
      fontWeight: 600,
      color: palette.primary.modalBorder,
      margin: '0 0 1.667rem 0 !important',
    },
  };
};

// @ts-expect-error TS(2345): Argument of type '({ palette }: any) => { gcpActio... Remove this comment to see the full error message
export default withStyles(styles, { withTheme: true })(ConnectorQuickView);
